/* eslint-disable no-return-assign */
import React, { useEffect, useState, useRef } from "react";
import { Box, Grid } from "@mui/material";
import MDBadgeDot from "components/MDBadgeDot";
import MDTypography from "components/MDTypography";
import TooltipLight from "utils/TooltipLight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

function Legend(props) {
  const { dataStructure } = props;
  const { labels, data, colors } = dataStructure;
  const total = data.length && data.reduce((a, v) => a + v);
  const [chunkedData, setChunkedData] = useState([]);
  const [scrollPosition, setScrollPosition] = useState(0);
  const containerRef = useRef();
  const scrollWidth = 150;

  useEffect(() => {
    const entries = Array.from(Array(data.length).keys());
    const chunks = [];
    const chunkSize = 4;
    for (let i = 0; i < data.length; i += chunkSize) {
      chunks.push(entries.slice(i, i + chunkSize));
    }
    setChunkedData(chunks);
  }, [props]);

  const getKPILegendDisplay = (index) => `${labels[index]}`;

  const getKPITooltipDisplay = (index) => {
    const percentage = Math.round((data[index] / total) * 100);
    return `${labels[index]}: ${percentage}% (${data[index]})`;
  };

  const handleScroll = (scrollOffset) => {
    let newScroll = scrollPosition + scrollOffset;
    newScroll = Math.max(newScroll, 0);
    setScrollPosition(newScroll);
    containerRef.current.scrollLeft = newScroll;
  };

  const renderLegendColumn = (chunk, chunkIndex) => (
    <Box
      key={`renderLegendColumn-${chunkIndex}`}
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "column",
        flexWrap: "wrap",
        width: "50%",
      }}
    >
      {chunk.map((index) => (
        <TooltipLight
          title={getKPITooltipDisplay(index)}
          arrow
          key={index}
          placement="left"
          variant="outline"
        >
          <Box
            sx={{
              display: "inline-flex",
              width: "100%",
            }}
          >
            <MDBadgeDot
              color="warning"
              size="lg"
              sx={{
                p: 0.5,
                i: {
                  background: colors[index],
                  mr: 0,
                  ml: "0.5rem",
                },
              }}
              badgeContent=""
            />
            <MDTypography
              sx={{
                fontSize: "0.7rem",
                fontWeight: "300",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                cursor: "default",
              }}
            >
              {getKPILegendDisplay(index)}
            </MDTypography>
          </Box>
        </TooltipLight>
      ))}
    </Box>
  );

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-evenly"
      wrap="nowrap"
      sx={{
        mb: 0,
      }}
    >
      {chunkedData?.length > 2 && (
        <Grid
          item
          p={0.4}
          alignItems="center"
          justifyContent="center"
          sx={{
            mb: "0.5rem",
          }}
        >
          <Box
            sx={{
              fontSize: "25px",
              display: "flex",
              alignItems: "center",
              mx: "-15px",
            }}
          >
            <KeyboardArrowLeftIcon
              style={{ cursor: "pointer", color: "#888" }}
              onClick={() => handleScroll(-scrollWidth)}
            />
          </Box>
        </Grid>
      )}
      <Grid
        item
        ref={containerRef}
        sx={{
          display: "inline-flex",
          width: "100%",
          mb: 0,
          // height: "100%",
          overflowX: "auto",
          scrollBehavior: "smooth",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
      >
        {chunkedData.map((chunk, index) => renderLegendColumn(chunk, index))}
      </Grid>
      {chunkedData?.length > 2 && (
        <Grid
          item
          p={0}
          alignItems="center"
          justifyContent="center"
          sx={{
            mb: "0.5rem",
          }}
        >
          <Box
            sx={{
              fontSize: "25px",
              display: "flex",
              alignItems: "center",
              marginLeft: "-5px",
            }}
          >
            <KeyboardArrowRightIcon
              style={{ cursor: "pointer", color: "#888" }}
              onClick={() => handleScroll(scrollWidth)}
            />
          </Box>
        </Grid>
      )}
    </Grid>
  );
}

export default Legend;
